import {
  GetFeedbackInvitationSchema,
  FormSchema,
  type SubmitFeedback,
  type Form,
} from "shared"
import { parseApiError } from "@rawa/api-client/ApiResponseError"

export async function fetchFeedbackForm(invitationId: string): Promise<Form> {
  const res = await fetch(
    `/api/feedback-invitations/${encodeURIComponent(invitationId)}/form`,
  )
  if (!res.ok) throw await parseApiError(res)
  return FormSchema.parse(await res.json())
}

export async function fetchInvitation(
  invitationId: string,
): Promise<{ firstName: string | null }> {
  const res = await fetch(`/api/feedback-invitations/${invitationId}`)
  if (!res.ok) throw await parseApiError(res)
  const { firstName } = GetFeedbackInvitationSchema.parse(await res.json())
  return { firstName }
}

export async function postFeedback(body: SubmitFeedback): Promise<void> {
  const res = await fetch("/api/feedback", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  })
  if (!res.ok) throw await parseApiError(res)
}
